import ResultsPredict from '@/components/pages/ResultsPredict/ResultsPredict'
import Rules from '@/components/pages/Rules'
import UserList from '@/components/pages/champions/UserList'
import Gifts from '@/components/pages/Gifts'

const routes = [
  {
    path: '/',
    name: 'Pronostic',
    component: ResultsPredict,
    meta: {
      title: 'Campionatul Mondial de Fotbal 2022 Qatar ⚽️ Fotbal.Enter.Online',
      metaTags: [
        {
          name: 'description',
          content: `⚽️ Ghicește scorul și ENTER Te Premiază! Dorești să câștigi un televizor,  consolă gaming, aparat de cafea sau alt premiu valoros? Ghicește rezultatul meciurilor din Campionatul Mondial de Fotbal 2022 Qatar.`
        }
      ]
    }

  },
  {
    path: '/clasament',
    name: 'Clasament',
    component: UserList,
    meta: {
      title: 'Clasamentul participanților pe ENTER la CM-22 Qatar',
      metaTags: [
        {
          name: 'description',
          content: `Verifică rezultatul tău la plasarea scorului din clasamentul meciurilor la campionatul mondial de fotbal 2022 Qatar.`
        }
      ]
    }
  },
  {
    path: '/premii',
    name: 'Premii',
    component: Gifts,
    meta: {
      title: 'Zeci de premii valoroase de la ENTER ⚽️ CM-2022 Qatar',
      metaTags: [
        {
          name: 'description',
          content: `Fii în trend! Prinde ritmul câștigătorilor. Participă la concursul organizat de ENTER în perioada Campionatului mondial de fotbal 2022, și chiar Tu poți deveni unul dintre norocoși.`
        }
      ]
    }
  },
  {
    path: '/reguli',
    name: 'Reguli',
    component: Rules,
    meta: {
      title: 'Regulament Ghicește Scorul ⚽️ CM-22 Qatar',
      metaTags: [
        {
          name: 'description',
          content: ``
        }
      ]
    }
  },
  {
    path: '/ru',
    name: 'Prognoz',
    component: ResultsPredict,
    meta: {
      title: 'Чемпионат мира по футболу 2022 Катар ⚽️ Fotbal.Enter.Online',
      metaTags: [
        {
          name: 'description',
          content: '⚽️ Угадай счет и ENTER вознаградит тебя! Хочешь выиграть телевизор, игровую приставку, кофеварку или другой ценный приз? Прогнозирую результат матчей ЧМ-2022 на нашем сайте.'
        }
      ]
    }
  },
  {
    path: '/ru/turnirnaja-tablica',
    name: 'Klasament',
    component: UserList,
    meta: {
      title: 'Участники ставок в Enter на ЧМ-22 Катар',
      metaTags: [
        {
          name: 'description',
          content: `Проверьте свой результат на свой ставки в рейтинге матчей на чемпионате мира по футболу 2022 Катар.`
        }
      ]
    }
  },
  {
    path: '/ru/prizy',
    name: 'Prizi',
    component: Gifts,
    meta: {
      title: 'Десятки ценных призов от ENTER ⚽️ ЧМ-2022 Катар',
      metaTags: [
        {
          name: 'description',
          content: `Будьте в тренде! Поймай темп победителей.  Участвуй в конкурсе от ENTER во время чемпионата мира по футболу 2022, и ты сможешь стать одним из счастливчиков.`
        }
      ]
    }
  },
  {
    path: '/ru/uslovija',
    name: 'Pravila',
    component: Rules,
    meta: {
      title: 'Регламент Ghicește Scorul  ⚽️ ЧМ-22 Катар',
      metaTags: [
        {
          name: 'description',
          content: ``
        }
      ]
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js